module.exports = __webpack_public_path__ + "img/file-black.844cf6ad.svg";